import React from 'react';
import { useSelector } from 'react-redux';
import { InfoIcon } from '../../../../../assets';
import { USER_ROLES, DEFAULT_PHONE_NUMBER_FORMAT } from '../../../../../constants/constants';
import { Tooltip } from '../../../../';
import { Input } from '../../../../formControls/Input/Input';
import { MaskInput } from '../../../../formControls/MaskInput/MaskInput';
import { renderSaveChangesButton } from './SaveChangesButton';

import styles from '../index.module.css';

/** Fixed destination for transportation operations notifications (not editable in-app). */
const TRANSPORTATION_OPERATIONS_EMAIL = 'transport@gomedhaul.com';

export const SupportContactsBlock = ({ initialValues, values, errors, handleSaveChanges }) => {
  const role = useSelector((state) => state.authorization?.role);
  const isMHAdmin = role === USER_ROLES.SUPER_ADMIN;

  return (
    <div className={styles.supportContactBlock}>
      <div className={styles.supportField}>
        <label className={styles.supportContact}>
          <span className={styles.required}>Contact email for notifications</span>
          <Input name='supportContacts.email' type='text' placeholder='Email' />
        </label>
        {initialValues?.supportContacts?.email !== values?.supportContacts?.email &&
          !Boolean(errors?.supportContacts?.email) &&
          renderSaveChangesButton(
            'supportContacts.email',
            handleSaveChanges,
            values,
            Boolean(errors?.supportContacts?.email),
          )}
      </div>
      {isMHAdmin && (
        <div className={styles.supportField}>
          <label className={styles.supportContact}>
            <span className={styles.transportOpsLabelRow}>
              <span className={styles.required}>Contact email for Transportation operations</span>
              <Tooltip
                title={
                  <span>Contact Medhaul engineering to update the email</span>
                }
              >
                <span className={styles.transportOpsTooltipTrigger}>
                  <InfoIcon width={30} height={30} />
                </span>
              </Tooltip>
            </span>
            <Input
              name='supportContacts.emailTransportationOperations'
              type='text'
              placeholder='Email'
              value={TRANSPORTATION_OPERATIONS_EMAIL}
              disabled
            />
          </label>
        </div>
      )}
      <div className={styles.supportField}>
        <label className={styles.supportContact}>
          <span className={styles.required}>Contact phone number for notifications</span>
          <MaskInput
            name='supportContacts.phoneNumber'
            format={DEFAULT_PHONE_NUMBER_FORMAT}
            myClassName={styles.supportEmail}
            placeholder={'###-###-####'}
            value={values?.supportContacts?.phoneNumber || ''}
          />
        </label>
        {initialValues?.supportContacts?.phoneNumber !== values?.supportContacts?.phoneNumber &&
          !Boolean(errors?.supportContacts?.phoneNumber) &&
          renderSaveChangesButton(
            'supportContacts.phoneNumber',
            handleSaveChanges,
            values,
            Boolean(errors?.supportContacts?.phoneNumber),
          )}
      </div>
    </div>
  );
};
